import { Rss } from "lucide-react";
import { RSS_URL } from "@/lib/blog";
import SubscribeForm from "@/components/blog/SubscribeForm";

export const FollowBlock = () => (
  <section
    id="follow"
    data-testid="follow-block"
    className="dark-section bg-[#0A0A0A] text-white py-20 lg:py-28"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-12 gap-y-10 lg:gap-x-10">
      <div className="col-span-12 lg:col-span-6">
        <div className="overline text-white/55">Follow the journal</div>
        <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]">
          Occasional notes.
          <br />
          <span className="italic font-normal text-white/60">No noise.</span>
        </h2>
      </div>
      <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex flex-col justify-end gap-6">
        <p className="text-white/65 leading-relaxed">
          New articles on fit-out, workshop craft and AI-led coordination — sent
          to your inbox when they're published. Unsubscribe any time.
        </p>
        <SubscribeForm source="blog" tone="dark" testid="follow-subscribe" />
        <a
          href={RSS_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="rss-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.18em] uppercase text-white/55 hover:text-white transition-colors"
        >
          <Rss size={12} /> RSS feed
        </a>
      </div>
    </div>
  </section>
);

export default FollowBlock;
